import { CheckIcon, XIcon } from '@heroicons/react/solid';
import { useEffect } from 'react';
import { useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { get_deployment, usePost } from './API';
import { ClickableButton } from './Components/Button';
import { TailwindSwitch } from './Components/Switch';
import { SpacedSpinner } from './Util';

// Form to submit new program handle and airtable Id to the backend using a custom hook
function AddNewProgram() {
    let [handle, setNewHandle] = useState('');
    let [programId, setProgramId] = useState('');
    const createProgram = usePost('/program/create')
    
    return (
        <>
            <div>
                <div className="mt-1 flex flex-column">
                    <label className="text-gray-300">Program Subdomain / DB Name</label>
                    <div className="flex flex-row">
                    <input type="text" 
                        placeholder="New Program Name" 
                        className="p-1 h-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={e => setNewHandle(e.target.value)} required/> 
                    </div>
                </div>
                <div className="mt-6 flex flex-column">
                    <label className="text-gray-300">Base Id from Airtable</label>
                    <input type="text" placeholder="Base Id from Airtable" 
                        className="p-1 h-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={e => setProgramId(e.target.value)} required/> 
                </div>
                <div className="mt-6 flex flex-row justify-end">
                    <ClickableButton color="indigo" colorIntensity={200}
                        onClick={async (e) => {
                        const result = await createProgram({handle, programId}); 
                        if (result && (result as any).status) {
                            toast.success(`Successfully created program ${handle}`);
                    }}}>Deploy</ClickableButton>
                </div>
            </div>
            <br />
        </>
    )
}

function ProvisionPage(props: any) {

    const ACCOUNT_TYPES: { id: 'support' | 'campaign', name: string, description: string }[] = [
        {
            id: 'support',
            name: 'Support',
            description: 'Used for Comms, nudges, and notifications.'
        },
        {
            id: 'campaign',
            name: 'Campaigns',
            description: 'Used for sending scheduled subsurveys and campaign messages in bulk.'
        }
    ];
    
    const [phoneNumbers, setPhoneNumbers] = useState([] as any[]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    
    const [areaCode, setAreaCode] = useState(0);
    const getPhoneNumbers = usePost('/messaging/search_numbers');
    const [program, setProgram] = useState(get_deployment());

    const [createMessagingService, setCreateMessagingService] = useState(false);
    const [createVerificationService, setCreateVerificationService] = useState(false);
    const [timer, setTimer] = useState(null as ReturnType<typeof setTimeout> | null);
    const getMessagingService = usePost('/messaging/service');
    const [preview, setPreview] = useState('');
    const [useCase, setUseCase] = useState('');
    const [useCaseMessages, setUseCaseMessages] = useState(['','','','','']);
    const [provisioning, setProvisioning] = useState(false);
    const [overwriteExisting, setOverwriteExisting] = useState(false);

    const [subaccount, setSubaccount] = useState('support' as typeof ACCOUNT_TYPES[0]['id']);
    const [serviceName, setServiceName] = useState(get_deployment());
    const [bought, setBought] = useState({} as any);
    const buyPhoneNumber = usePost('/messaging/provision_phone_number');
    const provisionService = usePost('/messaging/provision_service');
    const provisionVerificationService = usePost("/messaging/provision_verification_service");
    const [fetchingExistingService, setFetchingExistingService] = useState(false);
    const [existingService, setExistingService] = useState('');
    const [fetchedServiceName, setFetchedServiceName] = useState('');

    const [hasEmbeddedLinks, setHasEmbeddedLinks] = useState(false);

    const [addVoiceCalling, setAddVoiceCalling] = useState(false);
    const provisionTwiML = usePost('/messaging/provision_application');

    async function doProvision() {
        console.log("Provisioning...");
        setProvisioning(true);
        const result = await buyPhoneNumber({
            phoneNumber: preview,
            subaccount,
            program
        });
        console.log("buy phone outcome", result);

        setBought({
            phoneNumber: preview,
            phoneNumberSID: result.sid
        });

        if (result && result.sid && createMessagingService) {
            const service = await provisionService({
                name: serviceName,
                subaccount,
                program,
                phoneNumbers: [result.sid],
                overrideExistingService: overwriteExisting,
                useCase: {
                    name: useCase,
                    messageSamples: useCaseMessages,
                    hasEmbeddedLinks,
                    description: 'Default Support Messaging Service for ' + program
                }
            })
            console.log("Service outcome", service);

            setBought((prevState: any) => ({
                ...prevState,
                serviceSID: service.service,
                serviceName,
                useCase: service.useCase
            }));
        }

        if (addVoiceCalling) {
            const twiml = await provisionTwiML({
                name: serviceName,
                phoneNumber: result.sid,
                program
            });
            console.log("Provision TwiML outcome", twiml);
            setBought((prevState: any) => ({
                ...prevState,
                twiMLApplicationSID: twiml.application
            }));
        }

        console.log("RW", result, createVerificationService);
        if (result && result.sid && createVerificationService) {
            const verificationService = await provisionVerificationService({
                name: serviceName,
                subaccount
            });
            setBought((prevState: any) => ({
                ...prevState,
                verificationServiceSID: verificationService.service
            }))
        }

        setProvisioning(false);
    }

    useEffect(() => {
        if (timer) clearTimeout(timer);
        if (!serviceName) return;
        setFetchingExistingService(false);
        setTimer(setTimeout(() => {
            (async () => {
                setFetchingExistingService(true);
                const serviceExists = await getMessagingService({ 
                    name: serviceName, 
                    subaccount
                });
                setFetchedServiceName(serviceName);
                if (serviceExists && serviceExists.service) {
                    setExistingService(serviceExists.service);
                } else {
                    setExistingService('');
                }
                setFetchingExistingService(false);
            })()
        }, 500));

        return () => { if (timer) clearTimeout(timer) };
    }, [program, serviceName]);

    // input area code, get phone numbers
    return  <div className="bg-white">
        {/* Background color split screen for large screens */}
        <div className="hidden lg:block fixed top-0 left-0 w-1/2 h-full bg-indigo-900" aria-hidden="true" />
        <div className="hidden lg:block fixed top-0 right-0 w-1/2 h-full bg-white" aria-hidden="true" />

        <div className="relative grid grid-cols-1 gap-x-16 max-w-7xl mx-auto lg:px-8 lg:grid-cols-2 lg:pt-16">
        <section
            aria-labelledby="summary-heading"
            className="bg-indigo-900 text-indigo-300 py-12 md:px-10 lg:max-w-lg lg:w-full lg:mx-auto lg:px-0 lg:pt-0 lg:pb-24 lg:bg-transparent lg:row-start-1 lg:col-start-1"
        > 
            <div className="max-w-2xl mx-auto px-4 lg:max-w-none lg:px-0">
                <div className="mt-1 flex flex-column">
                    <h1>Add New Program</h1>
                    <AddNewProgram />
                </div>

                <div className="mt-1 flex flex-column">
                    <h2>Provision Voice/SMS/MMS Services</h2>
                    <label className="text-gray-300">Enter Area Code You Want to Provision</label>
                    <div className="flex flex-row">
                        <input type="text" autoFocus onChange={(e) => {
                            let val = e.target.value.replace(/[^0-9]/g, '');
                            setAreaCode(parseInt(val));
                        }} />&nbsp;
                        <ClickableButton color="green" onClick={async () => {
                            setLoading(true);
                            const numbers = await getPhoneNumbers({ areaCode, subaccount });
                            setLoading(false);
                            setPhoneNumbers(numbers);
                        }}>Get Numbers</ClickableButton>
                    </div>
                </div>

                <div className="mt-6 flex flex-column">
                    <label className="text-gray-300">OR Input Existing Phone Number you want to Add Services to</label>
                    <div className="flex flex-row">
                        <input type="text" className="block h-10 rounded w-full" 
                        onChange={(e) => {
                            let val = '+1' + e.target.value.replace(/[^0-9]|^1/g, '');
                            setPreview(val);
                        }} />&nbsp;
                    </div>
                </div>

            {loading && <div>Loading...</div>}
            <ul role="list" className="text-sm font-medium divide-y divide-white divide-opacity-10">
              {phoneNumbers.map((product) => (
                <li key={product.id} className="flex items-start py-6 space-x-4">
                  <ClickableButton color="blue" onClick={() => setPreview(product.phoneNumber)}>
                        {product.phoneNumber}
                    </ClickableButton>
                  <div className="flex-auto space-y-1">
                    <h3 className="text-white">{product.phoneNumber}</h3>
                    <p>{product.locality}</p>
                    <p>{product.region}</p>
                    <p>{product.postalCode}</p>
                  </div>
                  <p className="flex-none text-base font-medium text-white">{product.price}</p>
                </li>
              ))}
            </ul>
        </div>
        </section>
        {preview ? 
        <section
            aria-labelledby="payment-and-shipping-heading"
            className="py-16 lg:max-w-lg lg:w-full lg:mx-auto lg:pt-0 lg:pb-24 lg:row-start-1 lg:col-start-2"
        >
            <div className="max-w-2xl mx-auto px-4 lg:max-w-none lg:px-0">
                <div>
                    <h2 id="contact-info-heading" className="text-xl font-medium text-gray-900">
                    Purchase or Modify {preview}
                    </h2>

                    <div className="mt-6">
                        <label className="block text-sm font-medium text-gray-700">
                            Program (e.g. demo, chicagorcp, etc.)
                        </label>
                        <div className="mt-1">
                            <input type="text"
                                onChange={(e) => { 
                                    const value = (e.target.value && e.target.value.length > 0) ? e.target.value : get_deployment();
                                    
                                    setProgram(value)
                                    if (serviceName === '' || serviceName === program) {
                                        setServiceName(value)
                                    }
                                }}
                                className="p-1 h-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                    </div>

                    <div className="mt-6">
                        <TailwindSwitch label="Create Verification Service? (SMS Only, for 2FA)" 
                            checked={createVerificationService}
                            onChange={() => setCreateVerificationService(prevState => !prevState)}
                        />
                    </div>

                    <div className="mt-6">
                        <TailwindSwitch label="Create Messaging Service?" 
                            checked={createMessagingService}
                            onChange={() => setCreateMessagingService(prevState => !prevState)}
                        />
                    </div>

                    {createMessagingService ? 
                    <>
                    <div className="mt-6">
                    <fieldset>
                        <legend className="sr-only">Service Subaccount</legend>
                        <div className="space-y-5">
                            {ACCOUNT_TYPES.map((sa) => (
                            <div key={sa.id} className="relative flex items-start">
                                <div className="flex items-center h-5">
                                    <input
                                        id={sa.id}
                                        aria-describedby={`${sa.id}-description`}
                                        onChange={(e) => setSubaccount(sa.id)}
                                        type="radio"
                                        checked={sa.id === subaccount}
                                        className="focus:ring-indigo-500 h-4 w-5 cursor-pointer text-indigo-600 border-gray-300"
                                    />
                                </div>
                                <div className="ml-3 text-sm">
                                <label htmlFor={sa.id} className="cursor-pointer font-medium text-gray-700">
                                    {sa.name}
                                </label>
                                <p id={`${sa.id}-description`} className="text-gray-500">
                                    {sa.description}
                                </p>
                                </div>
                            </div>
                            ))}
                        </div>
                        </fieldset>
                    </div>

                    <div className="mt-6 col-span-3 sm:col-span-4">
                        <label className="block text-sm font-medium text-gray-700">
                            Service name, leave blank to use program ({program})
                        </label>
                        <div className="mt-1">
                            <input type="text"
                                onChange={(e) => {
                                    const value = (e.target.value && e.target.value.length > 0) ? e.target.value : program;
                                    setServiceName(value);
                                }}
                                className="p-1 h-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                            {fetchingExistingService && <div className="float-right" style={{position: "relative", top: "-33.5px"}}><SpacedSpinner />&nbsp;</div>}
                        </div>
                        {existingService && existingService.length > 0 ? 
                        <div className="flex flex-row"><div className="mr-1 my-auto">
                            <XIcon className="h-6 text-red-400" />
                        </div>
                        <small className="text-red-500 my-auto">A service already exists for this deployment with that name: {existingService}</small>
                        </div>
                        : serviceName && serviceName === fetchedServiceName && !fetchingExistingService ? 
                        <div className="flex flex-row justify-start">
                        <div className="mr-1 my-auto">
                            <CheckIcon className="h-6 text-green-400" />
                        </div>
                        <small className="text-gray-900 my-auto">The messaging service <code>{serviceName}</code> is available</small>
                        </div> : <></>}
                    </div>

                    <div className="mt-6">
                        <label className="block text-sm font-medium text-gray-700">
                            Use Case (i.e. notifications, delivery, etc)
                        </label>
                        <div className="mt-1">
                            <select className="block h-10" onChange={(e) => setUseCase(e.target.value)}>
                                <option value="">Select a use case</option>
                                <option value="DELIVERY_NOTIFICATION">Delivery Notifications</option>
                            </select>
                        </div>
                    </div>

                    {[1,2,3,4,5].map((i) => {
                        return <div className="mt-6 col-span-3 sm:col-span-4">
                        <label className="block text-sm font-medium text-gray-700">
                            Message sample {i}
                        </label>
                        <div className="mt-1">
                        <textarea
                            onChange={(e) => {
                                const messages = useCaseMessages.slice();
                                messages[i - 1] = e.target.value;
                                setUseCaseMessages(messages);
                            }}
                            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        </div>
                    </div>
                    })}

                    <div className="mt-6">
                        <TailwindSwitch label="Has embedded links" 
                            checked={hasEmbeddedLinks}
                            onChange={() => setHasEmbeddedLinks(prevState => !prevState)}
                        />
                    </div>

                    <div className="mt-6 flex items-center">
                        <TailwindSwitch label="Modify existing service"
                            checked={overwriteExisting}
                            onChange={() => setOverwriteExisting(prevState => !prevState)}
                        />
                    </div>
                    </>
                    : <></>}

                    <div className="mt-6">
                        <TailwindSwitch label="Add Voice Calling" labelDescription="(TwiML App)" 
                            checked={addVoiceCalling}
                            onChange={() => setAddVoiceCalling(prevState => !prevState)}
                        />
                    </div>

                    
                    

                    <div className="mt-10 flex justify-end pt-6 border-t border-gray-200">
                        <ClickableButton onClick={async () => await doProvision()}
                            color="indigo" colorIntensity={600} extraClasses="bg-indigo-600 text-white">
                            {provisioning && <SpacedSpinner />}Provision
                        </ClickableButton>
                    </div>

                    {bought && bought.phoneNumber ? <div className="mt-10">
                        <h2>Success!</h2>
                        {bought.phoneNumber ? <p>Bought number: {bought.phoneNumber} with SID {bought.phoneNumberSID}. Instructions: Copy the phone number to the Configuration value for key <code>twilio_mms_number</code></p> : <></>}
                        {bought.serviceSID ? <p><code>twilio_messaging_service_sid</code> - Messaging service {bought.serviceName} provisioned: <code>{bought.serviceSID}</code></p> : <></> }
                        {bought.useCase ? <p>Use case: {bought.useCase} (Not needed for configuration)</p> : <></>}
                        {bought.twiMLApplicationSID ? <p><code>twilio_twiml_app_sid</code> - TwiML Application provisioned: <span>{bought.twiMLApplicationSID}</span></p> : <></>}
                        {bought.verificationServiceSID ? <p><code>Verification Service SID</code> - <span>{bought.verificationServiceSID}</span> </p> : <></>}
                    </div>
                    : <></>}
                </div>
            </div>
        </section> : <></>}
        </div>
    </div>
}

export function NewProgramPage(props: any) {
    
    return <div className="p-8 items-center justify-center align-center">
        <ProvisionPage />
    </div>;
}